import { motion } from 'framer-motion';
import type { Pot } from '@/types';
import ChipStack from './ChipStack';

interface PotDisplayProps {
  pots: Pot[];
  className?: string;
}

export default function PotDisplay({ pots, className = '' }: PotDisplayProps) {
  const totalPot = pots.reduce((sum, pot) => sum + pot.amount, 0);
  const mainPot = pots[0]?.amount || 0;
  const sidePots = pots.slice(1);

  if (totalPot === 0) return null;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`flex flex-col items-center ${className}`}
    >
      {/* 主池 */}
      <div className="relative">
        <ChipStack amount={mainPot} size="lg" />
        <div className="absolute -top-6 left-1/2 -translate-x-1/2">
          <span className="bg-amber-600 text-white text-xs px-2 py-0.5 rounded-full font-bold">
 主池
          </span>
        </div>
      </div>

      {/* 边池 */}
      {sidePots.length > 0 && (
        <div className="flex gap-2 mt-4">
          {sidePots.map((pot, index) => (
            <div key={pot.id} className="relative">
              <ChipStack amount={pot.amount} size="md" />
              <div className="absolute -top-5 left-1/2 -translate-x-1/2">
                <span className="bg-slate-600 text-white text-xs px-1.5 py-0.5 rounded-full text-[10px]">
边池 {index + 1}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 总金额 */}
      <motion.div
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="mt-6 bg-black/60 backdrop-blur-sm rounded-full px-4 py-1"
      >
        <span className="text-amber-400 font-bold text-lg">
          总底池: {totalPot.toLocaleString()}
        </span>
      </motion.div>
    </motion.div>
  );
}
